module.exports = __webpack_public_path__ + "static/img/yspz_selected_image.5a2c0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/yspz_selected_image.png
// module id = c2HC
// module chunks = 44